import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { Grid, Row, Col, Button } from 'react-bootstrap';
import Link from '../../../components/Link';
import { Sprawy } from '../../sprawy/Sprawy';
import s from '../../content.scss';
import { wybierzGmine } from '../../../actions/gminy';
import PaperTile from '../../../components/PaperTile/PaperTile';
import PaperHeader from '../../../components/PaperHeader/PaperHeader';
import { notFoundImageURL } from '../../../config';
import Stepper, { Step } from '../../../components/Stepper';
import fetch from '../../../core/fetch';
import godloPolski from './godlo-Polski.png';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../../components/utils/utils';
import { replaceMultipleSpaces } from '../../../lib/utils';
import { portalMode } from '../../../config';
import { PODLASKIE_MODE, IHUB_URL } from '../../../constants'

import powrot_do_mapy from './powrot_do_mapy.png';
import cmentarzLogo from './logo_cmentarz.png';
import ihubLogo from './logo_inspire.png';
import AdaMapLogo from './AdaMap.png';


class SzczegolyUrzedu extends React.Component {
  state = {
    showKonto: false,
    showInfo: false,
    filter_text: '',
    colors: 'normal',
    style: layoutColorStyle,
  }

  componentDidMount() {
    const colors = getThemeFromLocalStorage();
    let style = layoutColorStyle;
    if (colors !== 'normal') {
      style = headerStyle;
    }
    this.setState({ colors, style });
  }

  serviceFilterChange = (e) => {
    // zamiana kilku spacji na jedną
    const value = replaceMultipleSpaces(e.target.value);
    this.setState({ filter_text: value });
  };

  getValue = field => {
    if (this.props.districts) {
      if (this.props.prefix) {
		const district = this.props.districts[this.props.prefix];
		if (district) {
		  return (Object.keys(field).indexOf(field) > -1) ? district[field] : '';
		} else return '';
	  } else return '';
	} else return '';
  }

  render() {
    let filteredServicesCount = 0;

    return (
      <div>
        { portalMode == PODLASKIE_MODE ?
          null
          :
          <Stepper>
            <Step title="Urzędy" url={'/urzad/'} />
            <Step title={this.getValue('place')} />
          </Stepper>
        }
        
        {
          this.props.districts && Object.keys(this.props.districts).filter(
            urzad => urzad === this.props.prefix
          ).map(
            (urzad, index) => {
              let herbUrl = notFoundImageURL;
              const urzadData = this.props.districts[urzad];

              // Utworzenie linku do herbu
              if (urzadData && urzadData.herb) {
                herbUrl = `https://e-spdp.pl/oldihub/upload/herby/${urzadData.herb}`;
              }

              return (
                <div key={index}>
                  <PaperHeader title={this.props.districts[urzad].name} text="" />
                  <div className="paper-area" style={{ color: this.state.style[this.state.colors].color, backgroundColor: this.state.style[this.state.colors].backgroundColor }}>
                    <Grid className="poszerz">
                      <Row>
                        <Col className="centruj" sm={2} xs={6}>
                          <img className="herby" role="presentation" src={godloPolski} />
                        </Col>
                        <Col className="centruj" smHidden mdHidden lgHidden xs={6}>
                          <img className="herby" role="presentation" src={herbUrl} />

                        </Col>
                        <Col xs={12} smHidden mdHidden lgHidden className="info-button">
                          <div role="button" onClick={() => this.setState({ showInfo: !this.state.showInfo })}>
                            <span>{!this.state.showInfo ? 'Pokaż dane gminy' : 'Ukryj dane gminy'}</span>
                            <span className={`fa fa-chevron-${!this.state.showInfo ? 'down' : 'up'}`} aria-hidden="true" />
                          </div>
                        </Col>
                        <Col className="centruj" xs={12} sm={8}>
                          <div className={`paper-content-area ${!this.state.showInfo ? 'ukryj-info' : null}`}>
                            <Row className="eus-specs"><Col xs={4}>Miejsce załatwiania:</Col><Col xs={8}>{this.props.districts[urzad].placeOfSettling}</Col></Row>
                            <Row className="eus-specs"><Col xs={4}>Miejscowość:</Col><Col xs={8}>{this.props.districts[urzad].place}</Col></Row>
                            <Row className="eus-specs"><Col xs={4}>Adres:</Col><Col xs={8}>{this.props.districts[urzad].street && this.props.districts[urzad].street.length !== 0 ? `${this.props.districts[urzad].street}` : this.props.districts[urzad].place}&nbsp;{this.props.districts[urzad].nrBuilding}{this.props.districts[urzad].nrLocal && this.props.districts[urzad].nrLocal.length !== 0 ? `/${this.props.districts[urzad].nrLocal}` : null}</Col></Row>
                            <Row className="eus-specs"><Col xs={4}></Col><Col xs={8}>{this.props.districts[urzad].zipCode}</Col></Row>
                            <Row className="eus-specs"><Col xs={4}>Telefon:</Col><Col xs={8}>{this.props.districts[urzad].phone}</Col></Row>
                            <Row className="eus-specs"><Col xs={4}>Faks:</Col><Col xs={8}>{this.props.districts[urzad].fax}</Col></Row>
                            <Row className="eus-specs"><Col xs={4}>Strona:</Col><Col xs={8}><a href={this.props.districts[urzad].pageWWW} target="_blank" rel="noopener noreferrer" style={{color: this.state.style[this.state.colors].color}}>{this.props.districts[urzad].pageWWW}</a></Col></Row>
                            <Row className="eus-specs"><Col xs={4}>Strona BIP:</Col><Col xs={8}><a href={this.props.districts[urzad].pageBIP} target="_blank" rel="noopener noreferrer" style={{color: this.state.style[this.state.colors].color}}>{this.props.districts[urzad].pageBIP}</a></Col></Row>
                            <Row className="eus-specs"><Col xs={4}>Adres e-mail:</Col><Col xs={8}><a href={`mailto:${this.props.districts[urzad].email}?subject=Dotyczy e-usług`} style={{color: this.state.style[this.state.colors].color}}>{this.props.districts[urzad].email}</a></Col></Row>
                            <Row className="eus-specs"><Col xs={4}>Godziny pracy urzędu:</Col><Col xs={8}>{this.props.districts[urzad].workingHours.map(
                              (item, i) => <div key={i}>{item}</div>,
                            )}</Col></Row>

                            <Row className="eus-specs">
                              <Col xs={4}>Konto:</Col>
                              {this.props.districts[urzad].bankAccounts.length === 1 ?
                                <Col xs={8}>{this.props.districts[urzad].bankAccounts.map(
                                  (item, i) => <div className="eus-item" key={i}>{item}</div>,
                                )}</Col>
                                :
                                <Col className={`${!this.state.showKonto ? 'ukryj' : null}`} xs={8}>
                                  <div onClick={() => this.setState({ showKonto: !this.state.showKonto })} className="wiecej-button">
                                    <span>{!this.state.showKonto ? 'Odkryj numer' : 'Ukryj numer'}</span>
                                    <span className={`fa fa-chevron-${!this.state.showKonto ? 'down' : 'up'}`} aria-hidden="true" />
                                  </div>
                                  <content>
                                    {this.props.districts[urzad].bankAccounts.map(
                                      (item, i) =>
                                        <div className="eus-item" key={i}>{item}</div>,
                                    )}
                                  </content>
                                </Col>
                              }
                            </Row>
                            <Row className="eus-specs">
                              <Col xs={12}>
                                <a id="deklaracja" href={`/urzad/${this.props.districts[urzad].prefix}/deklaracja-dostepnosci`} style={{color: this.state.style[this.state.colors].color}}>
                                  Deklaracja dostępności
                                </a>
                              </Col>
                            </Row>
                            <Row className="eus-specs"style={{ marginTop: '10px' }}>
                              <Col xs={3} />
                              <Col xs={6} style={{ textAlign: 'center' }}>
                                <a className="btn btn-primary" target='_blank' href={this.props.districts[urzad].mapPortalUrl}>
                                  <b>Portal mapowy</b>
                                </a>
                              </Col>
                              <Col xs={3} />
                            </Row>
                          </div>
                        </Col>
                        <Col xsHidden sm={2}>
                          <img
                            className="herby" role="presentation"
                            width="100"
                            src={herbUrl}
                          />
                        </Col>
                      </Row>
                      {/* <Row>
                        <Row className="eus-specs"style={{ marginTop: '10px' }}>
                          <Col xs={4} />
                          <Col xs={4} style={{ textAlign: 'center' }}>
                            <a className="btn btn-primary" target='_blank' href={this.props.districts[urzad].mapPortalUrl}>
                              <b>Portal mapowy</b>
                            </a>
                          </Col>
                          <Col xs={4} />
                        </Row>
                      </Row> */}
                    </Grid>
                  </div>
                  <PaperHeader title="E-usługi" text="" />
                  <Row>
                    <input type="text"
                      className="form-control"
                      style={{ width: '60%', left: '20%', position: 'relative', margin: '25px 0px 15px 0px' }}
                      value={this.state.filter_text}
                      placeholder="Wyszukaj usługę..."
                      onChange={(e) => this.serviceFilterChange(e)}
                    />
                    {this.props.districts[urzad].services
                    .filter(service => this.props.eservices[service].isEnabled === true)
                    .map(
                      (item, i) => {
                        const baseURL = (urzad === 'gmina_aleksandrow_lodzki') ? '/services' : '/eservices';
                        let baseQString = `${baseURL}?district=${this.props.districts[urzad].teryt}&serviceType=${item}`;
                        // if (this.props.user) {
                        //   baseQString += `&customerId=${this.props.user.ID}`;
                        // }
                        if (this.props.eservices[item].title.toLowerCase().includes(this.state.filter_text.toLowerCase())) {
                          filteredServicesCount += 1;
                          const daneUrzedu = this.props.districts[urzad];
                          const cardUrl = `/euslugi/${item}?district=${this.props.districts[urzad].teryt}`;
                          return (
                            <Col
                              key={i}
                              xs={12}
                              sm={6}
                              md={4}
                            >
                              <PaperTile
                                href={`${cardUrl}`}
                                text={this.props.eservices[item].title}
                                epuap={this.props.eservices[item].requiresEPUAP}
                                disabled={this.props.eservices[item].disabled}
                                wkLogin={daneUrzedu.wkLogin ? daneUrzedu.wkLogin : false}
                              />
                            </Col>
                          );
                        }
                      },
                    )}
                    {filteredServicesCount === 0 ?
                      <p style={{ width: '60%', left: '20%', position: 'relative', textAlign: 'center' }}>
                        Brak wyników wyszukiwania
                      </p>
                      : null}
                  </Row>
                </div>
              )
            },
          )
        }
      </div>
    );
  }
}
// export default withStyles(s)(SzczegolyUrzedu);

const mapState = (state) => ({
  wybranaGmina: state.gminy.wybranaGmina,
  districts: state.district.districts,
  eservices: state.district.eservices
});

const mapDispatch = {
  wybierzGmine,
};

export default withStyles(s)(connect(mapState, mapDispatch)(SzczegolyUrzedu));



// WEBPACK FOOTER //
// src/routes/urzad/szczegolyUrzedu/SzczegolyUrzedu.js